import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

export function BooleanDisplay({ value, hideFalse = false }) {
  return value ? <CheckIcon color="success" /> : !hideFalse ? <ClearIcon /> : '';
}
